/**
 * These variables are replaced by the contents of environment variables in setEnvVarsOnContainerStartup.sh when the container starts.
 * When changing the defaults, also change these in setEnvVarsOnContainerStartup.sh.
 */
export default {
  backendUrl: 'https://localhost:8080',
  backendWs: 'wss://localhost:8080',
  supportUrl: 'https://community.boomi.com/s/support',
  devPortalToken: '0qPG7xXzm65SnioUM2fK',
  insertTenantId: 'addTenantIdToBackendUrl',
  tinyEditorApiKey: 'udx2ebvck93caajup3lm2uilgj65r8klsu7ew7swvsw4u4zz',
  cookieConsent: 'allowCookieConsent',
};
